import React from 'react';
import { Location } from '@gatsbyjs/reach-router';

import PropTypes from 'prop-types';
import { ImageProps } from '../../../prop-types';
import { useSiteConfig } from '../../../hooks/site-config';

const isPreview = process.env.PREVIEW === 'true';

const MetaTags = ({
  siteName,
  metaImage,
  description,
  pageTitle,
  deindexPage,
  contentfulId,
  canonicalTag,
}) => {
  const { twitterHandle } = useSiteConfig();

  return (
    <Location>
      {() => (
        <>
          <title>{pageTitle}</title>
          <meta name="title" content={pageTitle} />
          <meta name="description" content={description} />
          {deindexPage || isPreview ? (
            <meta name="robots" content="noindex, nofollow" />
          ) : null}
          <meta property="og:title" content={pageTitle} />
          <meta property="og:description" content={description} />
          <meta property="og:url" content={canonicalTag} />
          <meta property="og:site_name" content={siteName} />
          <meta property="og:type" content="article" />
          <meta name="twitter:site" content={twitterHandle} />
          <meta name="twitter:creator" content={twitterHandle} />
          <meta name="entryId" content={contentfulId} />
          <link rel="canonical" href={canonicalTag} />
          {metaImage && <MetaImage metaImage={metaImage} />}
        </>
      )}
    </Location>
  );
};

const MetaImage = ({ metaImage }) => (
  <>
    <meta property="og:image" content={`https:${metaImage?.file?.url}`} />
    <meta property="og:image:alt" content={metaImage.description} />
    <meta property="og:image:type" content={metaImage.file.contentType} />
    {metaImage && metaImage.file.details && (
      <meta
        property="og:image:width"
        content={metaImage.file.details.image.width}
      />
    )}
    {metaImage && metaImage.file.details && (
      <meta
        property="og:image:height"
        content={metaImage.file.details.image.height}
      />
    )}
  </>
);

MetaTags.propTypes = {
  siteName: PropTypes.string,
  metaImage: ImageProps,
  description: PropTypes.string,
  pageTitle: PropTypes.string,
  deindexPage: PropTypes.bool,
  contentfulId: PropTypes.string,
  canonicalTag: PropTypes.string,
};

MetaImage.propTypes = {
  metaImage: PropTypes.object,
};

export default MetaTags;
